import { jsx as _jsx } from "react/jsx-runtime";
import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
export default function AuthWrapper(_a) {
    var children = _a.children;
    var navigate = useNavigate();
    //Handles redirect to admin page on login
    var onRedirectCallback = function (appState) {
        navigate((appState === null || appState === void 0 ? void 0 : appState.returnTo) || "/");
    };
    return (_jsx(Auth0Provider, { domain: "dev-oayu8epftihuelj1.us.auth0.com", clientId: "dxRIYZwKz8Zh790ccHzAwctQ3JcqJe1T", authorizationParams: {
            redirect_uri: window.location.origin,
            audience: "https://confectionco-api",
        }, onRedirectCallback: onRedirectCallback, children: children }));
}
